import {
  filter
} from 'min-dash';

import {
  isAny
} from '../modelElements/services/ModelingService';


export default function DistributionCheck(distributeElements) {

  distributeElements.registerFilter(function(elements) {
    return filter(elements, function(element) {
      const cannotDistribute = isAny(element, [
        'bpmn:Association',
        'bpmn:BoundaryEvent',
        'bpmn:DataInputAssociation',
        'bpmn:DataOutputAssociation',
        'bpmn:Lane',
        'bpmn:MessageFlow',
        'bpmn:Participant',
        'bpmn:SequenceFlow',
        'bpmn:TextAnnotation'
      ]);

      return !(element.labelTarget || cannotDistribute);
    });
  });
}

DistributionCheck.$inject = [ 'distributeElements' ];